



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import { UserTracks } from "@share/web-conferences/types/UserTracks";
import { UserProfile } from "@api/models/UserProfile";
import UserIcon from "@share/web-conferences/components/UserIcon.vue";
import NoMicIcon from '../../../assets/svg/no-mic.svg';
import { getWidth } from "@share/web-conferences/helpers/VideoWidthHelper";
import { EventBus } from "@common/EventBus";
import QualityIndicator from "@share/live-kit/components/common/QualityIndicator.vue";
// import { AgoraNetworkQuality } from "../agora/AgoraNetworkQuality";
import { LiveKitUserTracks } from "@share/live-kit/types/LiveKitUserTracks";
import { ConnectionQuality } from "livekit-client";
import { LiveKitSpeakingController } from "@share/live-kit/controllers/LiveKitSpeakingController";
import { LiveKitQualityController } from "@share/live-kit/controllers/LiveKitQualityController";

@Component({
    name: 'VideoStream',
    components: {UserIcon, NoMicIcon, QualityIndicator}
})
export default class VideoStream extends Vue {
    @Prop({required: true}) userTracks: LiveKitUserTracks;
    @Prop({required: true}) audioState: boolean;
    @Prop({required: true}) videoState: boolean;
    @Prop({required: true, default: null}) userProfile: UserProfile | null;
    // @Prop({required: true}) volume: number;
    @Prop({required: true}) totalTracksNumber: number;
    @Prop({default: false}) isMuted: boolean;
    @Prop({default: false}) isThereScreenSharing: boolean;
    @Prop({required: true}) speakingController: LiveKitSpeakingController;
    @Prop({required: true}) qualityController: LiveKitQualityController;
    // @Prop({ default: null }) sharingScreenTracks: UserTracks;
    // @Prop({}) quality: NetworkQualityStruct | undefined;

    get isMicEnabled(): boolean {
        return !!(this.userTracks.audio && !this.userTracks.audio.isMuted && this.audioState);
    }

    get isVideoEnabled(): boolean {
        return !!(this.userTracks.video && !this.userTracks.video.isMuted && this.videoState);
    }

    get profileLabel(): string | undefined {
        return [this.userProfile?.fullName, this.userProfile?.company, this.userProfile?.position].filter(item => item).join(', ');
    }

    get isSpeaking(): boolean {
        return this.speakingController.isSpeaking(this.userTracks.uid);
        // return this.volume >= 2 && this.isMicEnabled;
    }

    get width() {
        return getWidth(this.totalTracksNumber);
    }

    get quality() {
        return this.qualityController.userQuality(this.userTracks.uid, ConnectionQuality.Excellent);
    }

    // get isSharingUser() {
    //   return this.sharingScreenTracks && isUserSharing(this.userTracks.uid, this.sharingScreenTracks.uid);
    // }

    // get averageNetworkQuality() {
    //   return this.quality ? AgoraNetworkQuality.getAverageNetworkQuality(this.quality) : undefined;
    // }

    // get showQuality() {
    //   return this.averageNetworkQuality && this.averageNetworkQuality > 3;
    // }

    get currentUserId() {
        return this.$store.state.session.userId;
    }

    get isCurrentUser() {
        return this.currentUserId == this.userProfile?.userId;
    }

    get classes() {
        return {
            "is-speaking": this.isSpeaking,
            "is-with-video": this.isVideoEnabled,
            "is-small": this.isThereScreenSharing,
            "is-sharing": this.userTracks.isScreenShare,// this.isSharingUser,
            "is-one-row": this.totalTracksNumber <= 8,
            "is-local": this.userTracks.isLocal
        }
    }

    get styles(): Record<string, string> {
        let styles: any = {};
        if (!this.isThereScreenSharing) {

            if (this.userTracks.isScreenShare) {
                styles['height'] = '100%';
                styles['margin'] = 0;
            }
        }

        return styles;
    }

    get needToPlayAudio() {
        return !this.userTracks.isLocal && !this.isMuted && this.userTracks.audio && !this.userTracks.isLocal
    }

    get videoTrack() {
        return this.userTracks.video;
    }

    get audioTrack() {
        return this.userTracks.audio;
    }

    @Watch('videoTrack')
    onVideoTrackChanged() {
        if (this.videoTrack) {
            this.playVideo();
        }
    }

    @Watch('audioTrack')
    onAudioTrackChanged() {
        if (this.audioTrack) {
            this.playAudio();
        }
    }

    @Watch('isVideoEnabled')
    onIsVideoEnabledChanged(oldValue: boolean, newValue: boolean) {
        if (oldValue != newValue) {
            return;
        }

        // if (this.isVideoEnabled) {
        //   this.playVideo();
        // }
        // else {
        //   this.stopVideo();
        // }
    }

    updated() {
        this.play();
    }

    mounted() {
        this.play();
    }

    playAudio() {
        if (this.needToPlayAudio) {
            console.log('playing audio');
            try {
                this.userTracks.audio?.attach(this.$refs['audio'] as HTMLVideoElement);
            } catch (e) {
                this.$store.dispatch('reportException', e);
            }
        }
    }

    playVideo() {
        console.log('playing video')
        try {
            this.userTracks.video?.attach(this.$refs['video'] as HTMLVideoElement);
            (this.$refs['video'] as HTMLVideoElement).play();
        } catch (e) {
            this.$store.dispatch('reportException', e);
        }
    }

    stopVideo() {
        this.userTracks.video?.stop();
    }

    play() {
        this.playVideo();
        this.playAudio();
    }

    async openChat() {
        if (!this.isCurrentUser && this.userProfile?.userId) {
            EventBus.$emit("showChatByUserId", this.userProfile?.userId)
        }
    }

    destroyed() {
        const videoElement = (this.$refs['video'] as HTMLVideoElement)
        if (videoElement) {
            videoElement.src = "";
            videoElement.srcObject = null;
        }

        const audioElement = (this.$refs['audio'] as HTMLAudioElement)
        if (audioElement) {
            audioElement.src = "";
            audioElement.srcObject = null;
        }
    }

}

